import { CcModal } from "@utp/components-react";
import { Button } from "@utp/react-components-prod";
import { useEffect } from "react";
import { useConfigPromp } from "routes/context";

interface ModalConfig {
  onConfirm?: () => void;
  onCancel?: () => void;
}
interface Props<T> {
  isOpen: boolean;
  config: T;
}

const ModalConfirmation = <T extends ModalConfig>({
  isOpen,
  config,
}: Props<T>) => {
  const { setTabindex } = useConfigPromp();

  useEffect(() => {
    setTabindex(!isOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Escape") {
      if (config && typeof config.onCancel === "function") {
        config.onCancel();
      }
    }
  };

  return (
    <dialog className="flex justify-center mb-xxlg">
      <CcModal
        visible={isOpen}
        onCancel={config?.onCancel}
        hideCloseButton
        aria-describedby="modal-description"
        onKeyDown={handleKeyDown}
      >
        <div className="mb-lg">
          <h2
            id="modal-title"
            className="font-black text-heading-02 text-color-02 mb-lg text-center"
          >
            ¿Deseas rendir tu examen de admisión?
          </h2>
          <p id="modal-description" className="text-center text-color-02">
            Asegúrate de contar con internet estable y estar en un espacio sin
            distracciones.
          </p>
        </div>
        <div className="flex justify-center gap-lg flex-wrap modal-buttons">
          <Button
            text="No, regresar"
            color="primary"
            type="outline"
            data-testid="btn-cancel"
            onClick={config?.onCancel}
            className="focus:bg-primary-20"
          />

          <Button
            text="¡Sí, continuar!"
            color="primary"
            data-testid="btn-confirm"
            className="focus:bg-primary-60"
            onClick={config?.onConfirm}
          />
        </div>
      </CcModal>
    </dialog>
  );
};

export default ModalConfirmation;
